import { render, staticRenderFns } from "./EventCancellationPolicy_fr.vue?vue&type=template&id=5e11fb66&"
import script from "./EventCancellationPolicy_fr.vue?vue&type=script&lang=js&"
export * from "./EventCancellationPolicy_fr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports